import routes from "routes/routes";
import IRestaurant from "shared/interfaces/Restaurant.interface";

import apiInstance from "../api";

export default async (): Promise<IRestaurant[]> =>
  apiInstance.get(routes.restaurants.path).then((res) => res.data.data);
